module.exports = __webpack_public_path__ + "img/whathot_big03_words.8a912b61.jpg";